import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { Store } from "@ngrx/store";
import { CoreState, Jurisdiction, JurisdictionSelector } from "@obg/ngx.core";
import { coerceBoolean } from "@obg/ngx.global.evo";
import { Observable } from "rxjs";

@Component({
	selector: "obg-regulatory-items",
	templateUrl: "./regulatory-items.container.html",
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegulatoryItemsContainer implements OnInit {
	readonly dgaJurisdiction = Jurisdiction.Dga;
	readonly standardJurisdictions = [Jurisdiction.Iaui, Jurisdiction.Mta, Jurisdiction.Dgoj];

	@Input()
	@coerceBoolean()
	inGame = false;

	jurisdiction$: Observable<Jurisdiction | undefined> | undefined;

	constructor(private store: Store<CoreState>) {}

	ngOnInit() {
		this.jurisdiction$ = this.store.select(JurisdictionSelector.get);
	}
}
